import { useAppDispatch, useAppSelector } from "app/hooks";
import Panel from "shared/components/Panel";
import DataItem from "shared/components/DataItem";
import { setOpenPanel } from "features/settings/details-slice";
import AutoRotate from "./components/AutoRotate";
import Calibration from "./components/Calibration";
import Accordion from "shared/components/Accordion";
import { useCallback } from "react";
import ColourFilters from "./components/ColourFilters";
import Layers from "./components/Layers";

interface PanelSettingsProps {}
const PanelSettings: React.FC<PanelSettingsProps> = () => {
  const showPanel = useAppSelector(
    (state) => state.settings.openPanel === "settings"
  );
  const dispatch = useAppDispatch();
  const closePanel = useCallback(
    () => dispatch(setOpenPanel(null)),
    [dispatch]
  );

  return (
    <Panel
      showPanel={showPanel}
      direction="left"
      retainBottomMenu
      headerBorder="BorderBottom"
      closePanel={closePanel}
      underlayClass="NoUnderlay"
      headerElement={<h2>Settings</h2>}
    >
      <div className="DisplayFlex FlexColumn">
        <DataItem left={<h3>Auto-rotate</h3>} middle={<AutoRotate />} />
        <hr />
        <Accordion
          headerChildren={<h3>Calibration</h3>}
          bodyChildren={<Calibration />}
          withArrow
        />
        <hr />
        <Accordion
          headerChildren={
            <div className="DisplayFlex AlignBaseline NoGap">
              <h3>Indices</h3>
              <h6>&nbsp;&nbsp;-&nbsp;&nbsp;Experimental</h6>
            </div>
          }
          bodyChildren={<ColourFilters />}
          withArrow
          // initialOpen
        />
        <hr />
        <Accordion
          headerChildren={<h3>Layers</h3>}
          bodyChildren={<Layers />}
          withArrow
          initialOpen
        />
      </div>
    </Panel>
  );
};

export default PanelSettings;
